/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourceTypeDefinitionDto } from '../../models/data-source-type-definition-dto';

export interface DatasourceTypesGet$Json$Params {
}

export function datasourceTypesGet$Json(http: HttpClient, rootUrl: string, params?: DatasourceTypesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataSourceTypeDefinitionDto>>> {
  const rb = new RequestBuilder(rootUrl, datasourceTypesGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DataSourceTypeDefinitionDto>>;
    })
  );
}

datasourceTypesGet$Json.PATH = '/datasource-types';
